/**
 *
 * Created by jlado on 26/8/16.
 */
export class BankDocument {
    id:string;
    name:string;
    contentType:string;

    constructor(other?:BankDocument) {
        if (other) {
            this.id = other.id;
            this.name = other.name;
            this.contentType = other.contentType;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/bankDocument.ts
 **/